var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 7.105C4.125 3.181 7.203 0 11 0s6.875 3.181 6.875 7.105c0 3.924-3.078 7.105-6.875 7.105s-6.875-3.18-6.875-7.105ZM11 11.368c2.278 0 4.125-1.908 4.125-4.263 0-2.354-1.847-4.263-4.125-4.263S6.875 4.751 6.875 7.105c0 2.355 1.847 4.263 4.125 4.263ZM3.222 18.961C1.159 21.093 0 23.985 0 27h2.75c0-2.261.87-4.43 2.416-6.029A8.117 8.117 0 0 1 11 18.474c2.188 0 4.287.898 5.834 2.497A8.673 8.673 0 0 1 19.25 27H22c0-3.015-1.159-5.907-3.222-8.039-2.063-2.132-4.86-3.33-7.778-3.33-2.917 0-5.715 1.198-7.778 3.33Z",
    fill: "#333"
  })));
};
export default SvgUser;